import React from 'react';
import { useTranslation } from 'react-i18next';
import { TCN } from '../../tcn/ui-kit/tokens';

/**
 * Module 2 — A2.1 onboarding header strip.
 *
 * Four bucket-count cards (Critical / At risk / On track / Passed) matching the
 * mockup. Counts come from the page's client-side bucketing of the live creator
 * roster (single source of truth — more accurate than the denormalized
 * manager_current_month totals, which can drift between recomputes).
 *
 * Props:
 *   - buckets: { critical, at_risk, on_track, passed } — counts (numbers)
 */
const BUCKETS = [
  { key: 'critical', color: TCN.red },
  { key: 'at_risk', color: TCN.amber },
  { key: 'on_track', color: TCN.green },
  { key: 'passed', color: TCN.cyan },
];

const LABELS = {
  critical: 'Critical',
  at_risk: 'At risk',
  on_track: 'On track',
  passed: 'Passed',
};

const OnboardingHeaderStrip = ({ buckets = {}, isDesktop = false }) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: isDesktop ? 'grid' : 'flex',
        gridTemplateColumns: isDesktop ? 'repeat(4, 1fr)' : undefined,
        gap: 8,
        overflowX: isDesktop ? undefined : 'auto',
      }}
    >
      {BUCKETS.map((b) => (
        <div
          key={b.key}
          style={{
            padding: '10px 14px',
            borderRadius: 10,
            background: TCN.surface1,
            border: `1px solid ${b.color}33`,
            minWidth: isDesktop ? undefined : 78,
            flex: isDesktop ? undefined : '1 0 auto',
            textAlign: 'center',
          }}
        >
          <div
            style={{
              fontSize: 18,
              fontWeight: 700,
              color: b.color,
              fontVariantNumeric: 'tabular-nums',
              fontFamily: TCN.fontMono,
            }}
          >
            {buckets[b.key] ?? 0}
          </div>
          <div
            style={{
              fontSize: 10,
              color: TCN.textMute,
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
              marginTop: 2,
            }}
          >
            {t(`tcn.m2.bucket.${b.key}`, LABELS[b.key])}
          </div>
        </div>
      ))}
    </div>
  );
};

export default OnboardingHeaderStrip;
